export default "__VITE_ASSET__f90855d1__";